import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SET_REPORT_REQUEST_KEY } from 'components/Pages/Reports/actions.js';
import Box from '@bit/knotchinc.web-react-components.box';
import { StepContainer, Title, RadioItem, RadioItemTitle, RadioItemDesc } from './styled.js';

class ReportTypeStep extends Component {
  setValue(value) {
    const { setValid, setValue } = this.props;
    setValid(true);
    setValue(value);
  }

  render() {
    const { reportType } = this.props;

    return (
      <StepContainer>
        <Title>Choose what Report you’d like to create.</Title>
        <Box mt="48px">
          <RadioItem onClick={() => this.setValue('brand')} selected={reportType === 'brand'}>
            <RadioItemTitle>BRAND COMPARISON</RadioItemTitle>
            <RadioItemDesc>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </RadioItemDesc>
          </RadioItem>
          <RadioItem onClick={() => this.setValue('publisher')} selected={reportType === 'publisher'}>
            <RadioItemTitle>PUBLISHER COMPARISON</RadioItemTitle>
            <RadioItemDesc>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </RadioItemDesc>
          </RadioItem>
        </Box>
      </StepContainer>
    );
  }
}

ReportTypeStep.defaultProps = {
  name: 'Choose Report Type',
};

function mapStateToProps({ ReportRequest: {
   request: { report_type },
  } }) {
  return {
    reportType: report_type,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setValue: (value) => dispatch({
      type: SET_REPORT_REQUEST_KEY,
      payload: { report_type: value },
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportTypeStep);

